import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-policy-yuri-videos';
const html = `
<div data-show-title="true" data-attribute="card-title" class="card-title">
  <h2>See it in action</h2>
</div>
<div class="wrap-list-video">
  <div class="swiper policy-yuri-videos-swiper-unique-id">
    <div data-attribute="list-item" class="swiper-wrapper">
      <div data-attribute="item" class="swiper-slide">
        <div data-show-video="false" data-attribute="wrap-video" class="video-item" style="display: none;">
          <video data-attribute="video-item" loop autoplay muted src="" alt=""></video>
        </div>
        <div data-show-image="true" data-attribute="wrap-image" class="image-item" style="display: block;">
          <img src="https://cdn.skyfastimg.com/images/2026/05/06/image-69fae23a23eb955c76a8e4f6.webp" alt="">
        </div>
      </div>
      <div data-attribute="item" class="swiper-slide">
        <div data-show-video="true" data-attribute="wrap-video" class="video-item" style="display: block;">
          <video data-attribute="video-item" loop autoplay muted
            src="https://yurikoreanbeauty.com/cdn/shop/videos/c/vp/0d1ebdb9a952408fa86482ff4aee51d8/0d1ebdb9a952408fa86482ff4aee51d8.HD-720p-1.6Mbps-57768546.mp4?v=0"
            alt=""></video>
        </div>
        <div data-show-image="false" data-attribute="wrap-image" class="image-item" style="display: none;"></div>
      </div>
      <div data-attribute="item" class="swiper-slide">
        <div data-show-video="true" data-attribute="wrap-video" class="video-item" style="display: block;">
          <video data-attribute="video-item" loop autoplay muted
            src="https://yurikoreanbeauty.com/cdn/shop/videos/c/vp/215159f343c4429b9a77004a58cee25a/215159f343c4429b9a77004a58cee25a.HD-720p-1.6Mbps-57768548.mp4?v=0"
            alt=""></video>
        </div>
        <div data-show-image="false" data-attribute="wrap-image" class="image-item" style="display: none;"></div>
      </div>
      <div data-attribute="item" class="swiper-slide">
        <div data-show-video="true" data-attribute="wrap-video" class="video-item" style="display: block;">
          <video data-attribute="video-item" loop autoplay muted
            src="https://yurikoreanbeauty.com/cdn/shop/videos/c/vp/87c7b2457a8240c9ae780261949d28b6/87c7b2457a8240c9ae780261949d28b6.HD-720p-1.6Mbps-57768550.mp4?v=0"
            alt=""></video>
        </div>
        <div data-show-image="false" data-attribute="wrap-image" class="image-item" style="display: none;"></div>
      </div>
      <div data-attribute="item" class="swiper-slide">
        <div data-show-video="true" data-attribute="wrap-video" class="video-item" style="display: block;">
          <video data-attribute="video-item" loop autoplay muted
            src="https://yurikoreanbeauty.com/cdn/shop/videos/c/vp/a4ce1ad5b7884c2cbc6d083a74398a2a/a4ce1ad5b7884c2cbc6d083a74398a2a.HD-720p-1.6Mbps-57768551.mp4?v=0"
            alt=""></video>
        </div>
        <div data-show-image="false" data-attribute="wrap-image" class="image-item" style="display: none;"></div>
      </div>
    </div>
  </div>
  <div class="swiper-pagination"></div>
</div>
`;
export default containerFuild(html, css, {
  topPadding: false,
  bottomPadding: false,
});
